webpackJsonp([263791100135453],{

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Content = __webpack_require__(9);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var about = function about(_ref) {
	  var transition = _ref.transition;
	  return _react2.default.createElement(
	    "div",
	    { className: "Shell", style: transition && transition.style },
	    _react2.default.createElement(
	      _Content2.default,
	      { header: true },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "article",
	          { className: "Article mb4" },
	          _react2.default.createElement(
	            "header",
	            { className: "Article__header" },
	            _react2.default.createElement(
	              "h2",
	              null,
	              "Varf\xF6r har vi tagit fram det h\xE4r spelet?"
	            )
	          ),
	          _react2.default.createElement(
	            "section",
	            { className: "Article__section" },
	            _react2.default.createElement(
	              "p",
	              null,
	              "Vi tror att arbetsgivare och arbetss\xF6kande vinner p\xE5 att tydligt kunna uttrycka sina behov och vad de sj\xE4lva kan erbjuda."
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Vi vill visa p\xE5 v\xE4rdet i att uttrycka sig s\xE5 precist som m\xF6jligt och undvika floskler. Beskriv g\xE4rna kompetenser du beh\xF6ver f\xF6r en viss roll som beteenden. D\xE5 har du st\xF6rre chans att locka r\xE4tt person till din organisation. Att hitta r\xE4tt kompetens handlar om att fr\xE5ga efter r\xE4tt saker."
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "h2",
	              null,
	              "V\xE5rt arbete med pyramidanalysen"
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Idag f\xF6r\xE4ndras arbetsmarknaden snabbt. M\xE4nniskor beh\xF6ver r\xF6ra sig mellan olika branscher och yrken under ett arbetsliv. B\xE5de arbetsgivare och arbetss\xF6kande kan beh\xF6va bredda sina perspektiv och s\xE4tt att uttrycka sig. Vi vill stimulera det."
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Pyramidanalysen utg\xE5r ifr\xE5n arbetsmarknadens behov av kompetenser som \xE4r generella, det vill s\xE4ga s\xE5dana som \xE4r anv\xE4ndbara i m\xE5nga olika branscher. Vi har f\xF6rt en dialog om generella kompetenser med 200 arbetsgivare och arbetss\xF6kande samt ett antal branschorganisationer. Utifr\xE5n detta och arbetspsykologisk kunskap har v\xE5ra experter tagit fram denna enkla metod f\xF6r behovsanalys."
	            )
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "footer",
	            { className: "Article__footer" },
	            _react2.default.createElement(
	              "h2",
	              null,
	              "Kontakta oss"
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              "Vill du veta mer om hur vi arbetar med kompetenser?",
	              " ",
	              _react2.default.createElement(
	                "a",
	                {
	                  href: "mailto:projektet-kompetensmatchning@arbetsformedlingen.se?subject=Jag vill veta mer arbetet med kompetenser",
	                  className: "c-link"
	                },
	                "Mejla oss"
	              ),
	              " ",
	              "g\xE4rna. Eller",
	              " ",
	              _react2.default.createElement(
	                "a",
	                {
	                  className: "c-link",
	                  href: "https://docs.google.com/forms/d/e/1FAIpQLSfBcZulaFPtos0v5NC4WDbtCa77Q0k7n88LXp81Ig01vtyGdg/viewform"
	                },
	                "skicka feeback"
	              ),
	              " ",
	              "via v\xE5rt Google formul\xE4r."
	            )
	          )
	        )
	      )
	    )
	  );
	};
	exports.default = about;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-ee9cfebd151e52223f11.js